"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableFieldRow = void 0;
const react_1 = __importStar(require("react"));
const clsx_1 = __importDefault(require("clsx"));
const lodash_1 = require("lodash");
const Radio_1 = __importDefault(require("@material-ui/core/Radio/Radio"));
const Tooltip_1 = __importDefault(require("@material-ui/core/Tooltip"));
const Add_1 = __importDefault(require("@material-ui/icons/Add"));
const OpenInNew_1 = __importDefault(require("@material-ui/icons/OpenInNew"));
const SpeedDialAction_1 = __importDefault(require("@material-ui/lab/SpeedDialAction"));
const tooltip_1 = require("../tooltip/tooltip");
const event_callback_hook_1 = require("../../utils/event-callback-hook");
const tooltip_styles_1 = require("./../tooltip/tooltip-styles");
const text_cell_1 = require("./cells/text-cell");
const table_field_context_1 = require("./table-field-context");
const table_field_drag_handle_1 = require("./table-field-drag-handle");
const table_field_styles_1 = require("./table-field-styles");
exports.TableFieldRow = (0, react_1.memo)((0, react_1.forwardRef)(function TableFieldRow({ index, value, selected }, ref) {
    const classes = (0, table_field_styles_1.useStyles)();
    const tooltipClasses = (0, tooltip_styles_1.useStyles)();
    const { disabled, selectRow, showDetailDialog, filteredColumns, showDetailBtnCond, showRadioCond, showSpeedDialCond, speedDialActions, useDnDOrdering, onRowClick, visibleActionsColumn, actionColumnWidth, createRowStyle, highlightSelectedRow, } = (0, react_1.useContext)(table_field_context_1.TableFieldContext);
    const handleSelectClick = (0, event_callback_hook_1.useEventCallback)((e) => {
        e.stopPropagation();
        if (disabled && showDetailBtnCond(value)) {
            showDetailDialog(index);
        }
        if (!disabled && showRadioCond(value)) {
            selectRow(index);
        }
    });
    const handleRowClick = (0, event_callback_hook_1.useEventCallback)((e) => {
        if (onRowClick && onRowClick !== lodash_1.noop) {
            onRowClick(value, index);
        }
        else {
            handleSelectClick(e);
        }
    });
    const showDragButton = !disabled && useDnDOrdering;
    const showRadioButton = !disabled && showRadioCond(value);
    const showSpeedDialButton = !disabled && showSpeedDialCond(value);
    const showOpenButton = disabled && showDetailBtnCond(value);
    const rowStyle = createRowStyle(value);
    const [open, setOpen] = (0, react_1.useState)(false);
    const SpeedDialActions = (0, react_1.useMemo)(() => (react_1.default.createElement(react_1.default.Fragment, null, speedDialActions.map((action, i) => {
        var _a, _b, _c, _d;
        const visible = (_b = (_a = action === null || action === void 0 ? void 0 : action.show) === null || _a === void 0 ? void 0 : _a.call(action, value, index)) !== null && _b !== void 0 ? _b : true;
        const disabled = (_d = (_c = action === null || action === void 0 ? void 0 : action.disabled) === null || _c === void 0 ? void 0 : _c.call(action, value, index)) !== null && _d !== void 0 ? _d : false;
        if (!visible) {
            return null;
        }
        return (react_1.default.createElement(SpeedDialAction_1.default, { key: action.name, icon: react_1.default.createElement(action.Icon, { className: classes.tableSpeedDialIcon }), FabProps: {
                disabled,
                classes: {
                    disabled: classes.tableSpeedDialButtonDisabled,
                },
            }, TooltipClasses: tooltipClasses, tooltipTitle: action.name, tooltipPlacement: "top", open: true, onClick: () => action.onClick(value, index), className: (0, clsx_1.default)(classes.tableSpeedDialAction, classes.tableSpeedDialButton) }));
    }))), [
        classes.tableSpeedDialAction,
        classes.tableSpeedDialButton,
        classes.tableSpeedDialButtonDisabled,
        classes.tableSpeedDialIcon,
        index,
        speedDialActions,
        tooltipClasses,
        value,
    ]);
    return (react_1.default.createElement("div", { className: (0, clsx_1.default)(classes.row, {
            [classes.defaultCursor]: !showRadioButton && !showOpenButton,
            [classes.highlightedRow]: highlightSelectedRow && selected,
        }), style: rowStyle, onClick: handleRowClick, ref: ref },
        visibleActionsColumn && (react_1.default.createElement("div", { className: classes.tableRowActions, style: { width: actionColumnWidth } },
            showDragButton && react_1.default.createElement(table_field_drag_handle_1.DragHandle, { className: classes.rowDraggable }),
            showRadioButton && (react_1.default.createElement(Radio_1.default, { className: classes.radioButton, checked: selected, onClick: handleSelectClick, color: "primary" })),
            showSpeedDialButton && (react_1.default.createElement(Tooltip_1.default, { interactive: true, placement: "left", classes: {
                    tooltip: classes.tableSpeedDialTooltip,
                }, onOpen: () => setOpen(true), onClose: () => setOpen(false), open: open, TransitionProps: { timeout: 300 }, PopperProps: {
                    style: {
                        zIndex: 1200,
                    },
                }, title: SpeedDialActions },
                react_1.default.createElement("div", { className: classes.tableSpeedDialIcon },
                    react_1.default.createElement(Add_1.default, { style: {
                            transition: 'transform 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
                            transform: open ? 'rotate(45deg)' : 'rotate(0)',
                        } })))),
            showOpenButton && (react_1.default.createElement(tooltip_1.Tooltip, { title: "Otev\u0159e kr\u00E1tk\u00FD detail", placement: "top-start" },
                react_1.default.createElement(OpenInNew_1.default, { onClick: handleSelectClick }))))),
        filteredColumns.map((column, i) => {
            const { CellComponent = text_cell_1.TextCell } = column;
            return (react_1.default.createElement("div", { key: i, className: classes.cellWrapper, style: {
                    width: column.width,
                } },
                react_1.default.createElement(CellComponent, { index: index, value: (0, lodash_1.get)(value, column.datakey, null), rowValue: value, column: column })));
        })));
}));
//# sourceMappingURL=table-field-row.js.map